<app-navbar></app-navbar>

<!-- Content -->
<div class="container-fluid" id="top">
    <div class="row py-lg-5">
        <div class="col-sm-6 offset-sm-3 project-content">
            <mdb-card>
                <!-- Project's informations -->
                <mdb-card-title>
                    <!-- Project Title -->
                    <h2>PORTFOLIO EN HTML CSS JS </h2>
                    <!-- Project date + duration -->
                    <h4><b>Fin :</b> Novembre 2020</h4>
                    <h4><b>Durée :</b> 1 semaine</h4>
                </mdb-card-title>
                <!-- Project image -->

                <!-- About the project -->
                <mdb-card-body>
                    <!-- Technologies used -->
                    <div class="row technos">
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Technologies : </b></h4>
                                <img class="dot" src="assets/skills/html.png" />
                                <img class="dot" src="assets/skills/css.png" />
                                <img class="dot" src="assets/skills/github.png" />
                                <img class="dot" src="assets/js.png" />
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Tags : </b></h4>
                                <p> HTML,CSS, JS, Github</p>
                            </div>
                        </div>
                    </div>
                    <!-- Contenu du projet -->
                    <div class="row description">
                        <!-- Description of the project -->
                        <div class="col-sm-6">
                            <h4><b>Description :</b></h4>
                            <p>

                            </p>
                        </div>
                        <!-- Apports du projet -->
                        <div class="col-sm-6">
                            <h4><b>Bilan :</b></h4>
                            <p>
                                <a href="https://portfolio-coleau.000webhostapp.com/index.html" target="blank">Portfolio hébergé en ligne </a>

                            </p>
                        </div>

                        <img src="assets/site.png" width="1000">



                    </div>
                </mdb-card-body>
            </mdb-card>



        </div>
    </div>
</div>

<app-projects></app-projects>